import React, { useState } from 'react';
import './AddMemberModal.css'; // Reuse same styles

function EditTemporaryModal({ tempData, onClose, onSaved }) {
  const [formData, setFormData] = useState({
    first_name: tempData.first_name || '',
    last_name: tempData.last_name || '',
    network_id: tempData.network_id || '',
    country: tempData.country || '',
    city: tempData.city || '',
    notes: tempData.notes || ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validate required fields
    if (!formData.first_name || !formData.last_name || !formData.network_id) {
      setError('First name, last name, and network ID are required');
      setLoading(false);
      return;
    }

    try {
      // Prepare data for submission
      const submitData = {
        temp_id: tempData.id,
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim()
      };

      // Add required and optional fields
      submitData.network_id = formData.network_id.trim(); // Now required
      if (formData.country) submitData.country = formData.country.trim();
      if (formData.city) submitData.city = formData.city.trim();
      if (formData.notes) submitData.notes = formData.notes.trim();

      const response = await fetch('/backend/api/network/update-temporary.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(submitData)
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      if (data.success) {
        onSaved();
      } else {
        setError(data.error || 'Failed to update member');
      }
    } catch (error) {
      console.error('Error updating member:', error);
      setError('Failed to update member');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="add-member-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Team Member</h2>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="form-error">{error}</div>}

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="first_name">First Name *</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="last_name">Last Name *</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                className="form-input"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="network_id">Network Company ID *</label>
            <input
              type="text"
              id="network_id"
              name="network_id"
              value={formData.network_id}
              onChange={handleChange}
              className="form-input"
              placeholder="e.g., ABC123"
              required
            />
            <small className="form-hint">
              When they register with this ID, they'll be auto-linked
            </small>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="country">Country</label>
              <input
                type="text"
                id="country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                className="form-input"
                placeholder="e.g., USA"
              />
            </div>

            <div className="form-group">
              <label htmlFor="city">City</label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="form-input"
                placeholder="e.g., New York"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className="form-textarea"
              rows="3"
              placeholder="Optional notes about this person..."
            ></textarea>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn-cancel"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditTemporaryModal;

